import { styled, css } from '@vebox/etui-system';
import { createElement } from 'react';
import '../_rollupPluginBabelHelpers-3b7bd988.js';
import { Div, Span } from '@vebox/etui-system-elements';
import { H5 } from '../H5/H5.js';
import '../Svg-0180d7b5.js';
import Icon from '../Icon/Icon.js';
import '@vebox/etui-icons';
import { icons } from '../Icon/icons.js';
import '../Icon/helper.js';
import { createGlobalStyle } from 'styled-components';

const NotificationDetailsWrapperDiv = styled(Div)`
  ${({
  theme
}) => css`
    display: flex;
    font-family: ${theme.typography.fontFamily};
    font-size: ${theme.typography.fontSizeBase};
    color: ${theme.palette.text.primary};
  `};
`;

const NotificationIconSpan = styled(Span)`
  font-style: normal;
  text-align: center;

  ${({
  color
}) => color && css`
      color: ${color};
    `};
`;

const NotificationTitleH5 = styled(H5).attrs(({
  theme
}) => ({
  pr: `${theme.spacing.lg}px` // Avoids overlap on close icon
}))`
  display: inline-block;
  margin-bottom: 0;
`;

const NotificationGlobalStyles = createGlobalStyle`
  .notification {
    position: fixed;
    z-index: 1000;
    max-width: 325px;
    width: 100%;
  }

  .notification-notice {
    padding: ${({
  theme
}) => `${theme.spacing.md}px`};
    border-radius: ${({
  theme
}) => `${theme.shape.borderRadius}`};
    background-color: ${({
  theme
}) => `${theme.palette.common.white}`};
    box-shadow: ${({
  theme
}) => `${theme.shadows[10]}`};
    border: none;
    display: block;
    width: 100%;
    line-height: 1.5;
    position: relative;
    margin: ${({
  theme
}) => `${theme.spacing.md}px 0`};
  }

  .notification-notice-close {
    position: absolute;
    right: ${({
  theme
}) => theme.spacing.xs}px;
    top: ${({
  theme
}) => theme.spacing.xs}px;
    color: ${({
  theme
}) => `${theme.palette.black[60]}`};
    cursor: pointer;
    outline: none;
    font-size: 16px;
    font-weight: 700;
    line-height: 1;
    text-shadow: 0 1px 0 ${({
  theme
}) => `${theme.palette.common.white}`};
    text-decoration: none;
    transition: 0.2s;
  }

  .notification-notice-close-x:after {
    content: '×';
  }

  .notification-notice-close:hover {
    filter: brightness(0.6);
    text-decoration: none;
  }

  .notification-fade-enter {
    transform: translateX(110%);
    animation-duration: 0.3s;
    animation-fill-mode: both;
    animation-timing-function: cubic-bezier(0.55, 0, 0.55, 0.2);
    animation-play-state: paused;
  }

  .notification-fade-leave {
    animation-duration: 0.3s;
    animation-fill-mode: both;
    animation-timing-function: cubic-bezier(0.55, 0, 0.55, 0.2);
    animation-play-state: paused;
  }

  .notification-fade-enter.notification-fade-enter-active {
    animation-name: NotificationFadeIn;
    animation-play-state: running;
  }

  .notification-fade-leave.notification-fade-leave-active {
    animation-name: DialogFadeOut;
    animation-play-state: running;
  }

  @keyframes NotificationFadeIn {
    0% {
      transform: translateX(110%);
    }
    100% {
      transform: translateX(0);
    }
  }
  @keyframes DialogFadeOut {
    0% {
      transform: translateX(0);
    }
    100% {
      transform: translateX(110%);
    }
  }`;

const NotificationDetails = props => /*#__PURE__*/createElement(NotificationDetailsWrapperDiv, {
  theme: props.theme
}, /*#__PURE__*/createElement(NotificationGlobalStyles, {
  theme: props.theme
}), props.showIcon && props.messageType === 'success' && /*#__PURE__*/createElement(NotificationIconSpan, {
  id: "success",
  color: props.theme.palette.success.main,
  theme: props.theme
}, /*#__PURE__*/createElement(Icon, {
  glyph: icons.SUCCESS_BUBBLE_FILLED,
  size: 48
})), props.showIcon && props.messageType === 'info' && /*#__PURE__*/createElement(NotificationIconSpan, {
  id: "info",
  color: props.theme.palette.info.main,
  theme: props.theme
}, /*#__PURE__*/createElement(Icon, {
  glyph: icons.INFO_BUBBLE_FILLED,
  size: 48
})), props.showIcon && props.messageType === 'warning' && /*#__PURE__*/createElement(NotificationIconSpan, {
  id: "warning",
  color: props.theme.palette.warning.main,
  theme: props.theme
}, /*#__PURE__*/createElement(Icon, {
  glyph: icons.WARNING_FILLED,
  size: 48
})), props.showIcon && props.messageType === 'error' && /*#__PURE__*/createElement(Span, {
  id: "error",
  color: props.theme.palette.error.main,
  theme: props.theme
}, /*#__PURE__*/createElement(Icon, {
  glyph: icons.ERROR_BUBBLE_FILLED,
  size: 48
})), /*#__PURE__*/createElement(Div, {
  pl: props.showIcon ? props.theme.spacing.md : null,
  theme: props.theme
}, props.title && /*#__PURE__*/createElement(NotificationTitleH5, {
  theme: props.theme
}, props.title), props.subtitle && /*#__PURE__*/createElement(Div, {
  color: props.theme.palette.text.secondary,
  theme: props.theme
}, props.subtitle), props.description && /*#__PURE__*/createElement(Div, {
  color: props.theme.palette.text.secondary,
  theme: props.theme
}, props.description)));

export default NotificationDetails;
